module.exports = __webpack_public_path__ + "static/media/es-ct.2f1565e8.svg";